import { Label } from "reactstrap";
import { ChoiceEmployee, SelectOption } from "../../../globals/interfaces";
import Select from "../../../components/Select";
import styled from "styled-components";
import ActionIcon from "../../../components/custom/ActionIcon";

export default function SearchEmployee ({
    employees,
    searchEmployee,
    setSearchEmployee
}: {
    employees: Array<ChoiceEmployee>;
    searchEmployee: string;
    setSearchEmployee: React.Dispatch<React.SetStateAction<string>>;
}) {

    const employeeOptions: Array<SelectOption> = employees.map(emp => ({ label: `${emp.s_first_name} ${emp.s_last_name}`, value: emp.s_email }));

    return (
        <div>
            <Label>Search Employee</Label>
            <FlexContainer>
                <Select 
                    options={employeeOptions}
                    value={searchEmployee}
                    onChange={item => setSearchEmployee(String(item.value))}
                    width={300}
                />
                <ActionIcon 
                    type={'cancel'}
                    onClick={() => setSearchEmployee('')}
                    className={'ml-2'}
                />
            </FlexContainer>
        </div>
    );
}

const FlexContainer = styled.div`
    display: flex;
`;